<div class="dashletActivity">
  @switch (type) {
    @case (customFieldTypes.LIST) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_LIST_ACTIVITY"
        />
    }
    @case (customFieldTypes.PERCENTAGE) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_PERCENTAGE_ACTIVITY"
        />
    }
    @case (customFieldTypes.NUMBERS) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_NUMBERS_ACTIVITY"
        />
    }
    @case (customFieldTypes.COST) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_COST_ACTIVITY"
        />
    }
    @case (customFieldTypes.TIME) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_TIME_ACTIVITY"
        />
    }
    @case (customFieldTypes.DATE) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_DATE_ACTIVITY"
        />
    }
    @case (customFieldTypes.CHECKBOX) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_CHECKBOX_ACTIVITY"
        />
    }
    @case (customFieldTypes.RICHTEXT) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_RICH_TEXT_ACTIVITY"
        />
    }
    @case (customFieldTypes.TEXT) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_TEXT_ACTIVITY"
        />
    }
    @case (customFieldTypes.TIMELINE) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_TIMELINE_ACTIVITY"
        />
    }
    @case (EIntegrationStatus.ON) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL"
        />
    }
    @case (EIntegrationStatus.DISABLED) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL"
        />
    }
  }

  <div class="dashletActivity__text">
    @if (!ppChange.oldValue) {
      {{ 'changed' | ppTranslate }}
      <span class="dashletActivities__item-quoted timeline__strong">{{ ppChange.label }}</span>
      {{ 'to' | ppTranslate | lowercase }}
      <span class="dashletActivities__item-quoted">{{ ppChange.newValue }}.</span>
    }

    @if (ppChange.oldValue) {
      <ng-container class="dashletActivity">
        {{ ppChange.label }} {{ 'changed' | ppTranslate }} {{ 'to' | ppTranslate | lowercase }}
        <span class="dashletActivities__item-quoted">{{ ppChange.newValue }}.</span>
      </ng-container>
    }
  </div>
</div>
